import { useEffect, useState } from 'react';
import './Gallery.css';

const Gallery = () => {
  const [items, setItems] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/gallery/`)
      .then(res => res.json())
      .then(data => {
        setItems(data);
        if (data.length > 0) setActiveIndex(0);
      })
      .catch(err => console.error('Error fetching gallery:', err));
  }, []);

  if (items.length === 0) return null;

  const getImages = (item) =>
    [item.image_1, item.image_2, item.image_3, item.image_4].filter(Boolean);

  return (
    <section id="gallery" className="section gallery" aria-label="Gallery section">
      <div className="container">
        <h2 className="section-title">Gallery</h2>

        <div className="accordion">
          {items.map((item, i) => {
            const images = getImages(item);
            const isOpen = activeIndex === i;

            return (
              <div key={item.id} className={`accordion-item ${isOpen ? 'open' : ''}`}>
                <button
                  className="accordion-header"
                  onClick={() => setActiveIndex(isOpen ? null : i)}
                  aria-expanded={isOpen}
                >
                  <div className="accordion-header-text">
                    <span className="accordion-title">{item.title}</span>
                    {item.subtitle && (
                      <span className="accordion-subtitle">{item.subtitle}</span>
                    )}
                  </div>
                  <span className="accordion-icon">{isOpen ? '−' : '+'}</span>
                </button>

                <div className="accordion-body">
                  {item.description && (
                    <p className="accordion-description">{item.description}</p>
                  )}
                  {images.length > 0 && (
                    <div className={`gallery-grid cols-${Math.min(images.length, 4)}`}>
                      {images.map((src, idx) => (
                        <div key={idx} className="gallery-img-wrap">
                          <img
                            src={src}
                            alt={`${item.title} ${idx + 1}`}
                            loading="lazy"
                            className="gallery-img"
                          />
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
